

exports.__esModule = true;
exports.sanitizeRedirectUrl = sanitizeRedirectUrl;

var _logger = require('xo-beaver/dist/logger');

var ALLOWED_PROTOCOLS = ['http:', 'https:'];

/**
 * Validates a URL intended for external redirect (e.g., "Return to merchant").
 * Returns the URL if safe, or null if it should be blocked.
 *
 * Checks:
 *  1. Non-empty string
 *  2. Protocol is http: or https: (blocks javascript:, data:, vbscript:, etc.)
 *  3. Strips embedded credentials (user:pass@host)
 */
function sanitizeRedirectUrl(url) {
    if (!url || typeof url !== 'string') {
        return null;
    }

    try {
        var parsed = new URL(url);

        if (parsed.username || parsed.password) {
            parsed.username = '';
            parsed.password = '';
        }

        if (!ALLOWED_PROTOCOLS.includes(parsed.protocol)) {
            _logger.$logger.error('blocked_redirect_bad_protocol', {
                url: url,
                protocol: parsed.protocol
            });
            return null;
        }

        return parsed.href;
    } catch (err) {
        _logger.$logger.error('redirect_url_parse_error', {
            url: url,
            error: err && err.message
        });
        return null;
    }
}

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./js/lib/redirectSanitizer.js
// module id = ./js/lib/redirectSanitizer.js
// module chunks = 0